// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreatePeriodForEmployeeInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/create_period_for_employee
 *
 * Validates input for creating a payroll period for a specific employee.
 * Accepts date-only values (YYYY-MM-DD) - times are set automatically by the controller.
 */
import { registerContract } from './validate'

export interface Payroll_CreatePeriodForEmployeeInput {
user_id: string
franchise_id: number
period_start_date: string
period_end_date: string
}

registerContract('Payroll_CreatePeriodForEmployeeInput', {
  user_id:           { type: 'string',  required: true },
  franchise_id:      { type: 'number',  required: true },
  period_start_date: { type: 'string',  required: true },
  period_end_date:   { type: 'string',  required: true },
})
